export const FETCH_SOLAR_ENERGY_GENERATED_REQUEST =
  '[SolarEnergyGenerated] FETCH_SOLAR_ENERGY_GENERATED_REQUEST';
export const FETCH_SOLAR_ENERGY_GENERATED_SUCCESS =
  '[SolarEnergyGenerated] FETCH_SOLAR_ENERGY_GENERATED_SUCCESS';
export const FETCH_SOLAR_ENERGY_GENERATED_FAILURE =
  '[SolarEnergyGenerated] FETCH_SOLAR_ENERGY_GENERATED_FAILURE';
